import React from 'react';
import classNames from 'classnames';
import { useSweLang } from '../../platformui/Helpers/helpers';

const EventListViewToggler = (props) => {
  return (
    <div className="list-view-toggler">
      <span
        className="list-view-toggler__text"
        lang={useSweLang(props.Language)}
      >
        {props.translations.showcontentas}
      </span>
      <button
        className={classNames({
          'list-view-toggler__btn': true,
          'list-view-toggler__btn--brickview': true,
          'list-view-toggler__btn--is-selected': props.toggleBrickView,
        })}
        aria-checked={props.toggleBrickView}
        role="radio"
        type="radio"
        onClick={() => props.onClick(true)}
      >
        <span className="show-for-sr" lang={useSweLang(props.Language)}>
          {props.translations.showasbricks}
        </span>
      </button>
      <button
        className={classNames({
          'list-view-toggler__btn': true,
          'list-view-toggler__btn--listview': true,
          'list-view-toggler__btn--is-selected': !props.toggleBrickView,
        })}
        aria-checked={!props.toggleBrickView}
        role="radio"
        type="radio"
        onClick={() => props.onClick(false)}
      >
        <span className="show-for-sr" lang={useSweLang(props.Language)}>
          {props.translations.showaslist}
        </span>
      </button>
    </div>
  );
};

export default EventListViewToggler;
